import { render, staticRenderFns } from "./DialogSectionRoomComponent.vue?vue&type=template&id=08b1f366&scoped=true&"
import script from "./DialogSectionRoomComponent.vue?vue&type=script&lang=js&"
export * from "./DialogSectionRoomComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogSectionRoomComponent.vue?vue&type=style&index=0&id=08b1f366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1f366",
  null
  
)

export default component.exports